export default {
  app: {
    quiz: {
      nrOfCorrectAnswers: 'Respostas corretas: {state}',
    },
  },
};
